import ListingStates from '../../../constants/listings/ListingStates'
import { readQueryParams, replaceQueryParams } from '../../../utils/pagination'
import { DEFAULT_PER_PAGE, ListingFilters } from './Constants'
import config from '../../../config'

const filterStates = test =>
  Object.entries(ListingStates)
    .filter(test)
    .map(e => e[0])

export const ActiveStates = filterStates(entry => entry[1].isActive === true).join(',')
export const InactiveStates = filterStates(entry => entry[1].isActive === false).join(',')
export const FailedStates = filterStates(entry => entry[1].id.includes('FAILED'))
  .filter(s => s !== 'MODIFY_FAILED')
  .join(',')
export const conformDate = ([start, end]) => (start && end ? [new Date(start), new Date(end)] : null)

export const BlankState = s => ({
  meta: {
    perPage: s.meta.perPage || DEFAULT_PER_PAGE,
    page: 1,
    sort: 'id.desc',
    tab: 'active-all'
  }
})

export const InitialState = () => {
  const queryParams = readQueryParams()

  let { createdAt, startTime, endTime, productCreatedAt } = queryParams

  createdAt = createdAt ? conformDate(createdAt) : null
  startTime = startTime ? conformDate(startTime) : null
  endTime = endTime ? conformDate(endTime) : null
  productCreatedAt = productCreatedAt ? conformDate(productCreatedAt) : null

  const cursorParams = config.CURSOR_PAGINATED_LISTING_MANAGER() ? { cursor: queryParams.cursor || null } : {}

  return {
    page: queryParams.page || 1,
    perPage: queryParams.perPage || DEFAULT_PER_PAGE,
    ...cursorParams,
    sort: queryParams.sort || 'id.desc',
    userId: queryParams.userId || null,
    sku: queryParams.sku || null,
    title: queryParams.title || null,
    state: queryParams.state || null,
    marketId: queryParams.marketId || null,
    categoryName: queryParams.categoryName || null,
    tab: queryParams.tab || 'active-all',
    total: 0,
    maxPages: 0,
    supplierId: queryParams.supplierId || null,
    carrierId: queryParams.carrierId || null,
    externalMarketId: queryParams.externalMarketId || null,
    inventoryLocationId: queryParams.inventoryLocationId || null,
    productId: queryParams.productId || null,
    tags: queryParams.tags || [],
    createdAt,
    startTime,
    endTime,
    productCreatedAt,
    listingErrors: queryParams.listingErrors || null
  }
}

export const clearUnusedDates = meta => {
  const fullDateOrNull = date => date && date.length && date[0] && date[1] && date

  return {
    createdAt: fullDateOrNull(meta.createdAt),
    startTime: fullDateOrNull(meta.startTime),
    endTime: fullDateOrNull(meta.endTime),
    productCreatedAt: fullDateOrNull(meta.productCreatedAt)
  }
}

export const Persist = meta => {
  replaceQueryParams(meta)
}

export const StateFilter = state => {
  if (state === ListingFilters.ACTIVE) {
    return ActiveStates
  }
  return InactiveStates
}
